import React, { useState } from 'react';
import { User, Briefcase, Pencil, Trash2 } from 'lucide-react';
import { PARTICIPANT_ROLES_LABELS } from '../../../../constants/participantRoles';
import AlertModal from '../../../../components/ui/AlertModal';
import Tooltip from '../../../../components/ui/Tooltip';

export default function ParticipantsList({ participants = [], onEdit, onDelete }) {
  const [participantToDelete, setParticipantToDelete] = useState(null);

  if (participants.length === 0) {
    return (
      <div className="text-center py-10">
        <User className="mx-auto h-12 w-12 text-tertiary" />
        <h3 className="mt-2 text-sm font-semibold text-primary">Aucun intervenant</h3>
        <p className="mt-1 text-sm text-tertiary">Ajoutez des partenaires et contacts liés au dossier.</p>
      </div>
    );
  }

  const handleDeleteConfirm = () => {
    if (participantToDelete && onDelete) {
      onDelete(participantToDelete.id);
    }
    setParticipantToDelete(null);
  };

  return (
    <>
      <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {participants.map((participant) => (
          <li
            key={participant.id}
            className="group relative flex items-start space-x-4 rounded-xl border border-workspace bg-surface p-4 hover:border-primary/20 hover:shadow-hp-sm transition-all duration-200"
          >
            <div className="flex-shrink-0 mt-1">
              <div className="h-10 w-10 rounded-full bg-surface-muted flex items-center justify-center border border-workspace">
                {participant.role === 'Avocat' || participant.role === 'Notaire' || participant.role === 'Expert-Comptable' ? (
                  <Briefcase className="h-5 w-5 text-brand" />
                ) : (
                  <User className="h-5 w-5 text-brand" />
                )}
              </div>
            </div>
            <div className="min-w-0 flex-1 pr-14">
              <p className="text-sm font-bold text-primary line-clamp-1 pr-2">
                {participant.name}
              </p>
              <p className="text-xs font-semibold text-brand mt-0.5">
                {PARTICIPANT_ROLES_LABELS?.[participant.role] || participant.role}
              </p>
              {participant.contactNotes && (
                <p className="text-xs text-tertiary mt-2 line-clamp-2">
                  {participant.contactNotes}
                </p>
              )}
            </div>

            {/* Actions (visible au survol) */}
            <div className="absolute top-3 right-3 flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
              <Tooltip content="Modifier">
                <button
                  onClick={() => onEdit && onEdit(participant)}
                  className="p-1.5 text-tertiary hover:text-primary bg-surface-muted rounded-md border border-transparent hover:border-workspace transition-colors"
                >
                  <Pencil className="w-4 h-4" />
                </button>
              </Tooltip>
              <Tooltip content="Supprimer">
                <button
                  onClick={() => setParticipantToDelete(participant)}
                  className="p-1.5 text-tertiary hover:text-danger-500 bg-surface-muted rounded-md border border-transparent hover:border-workspace transition-colors"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              </Tooltip>
            </div>
          </li>
        ))}
      </ul>

      <AlertModal
        isOpen={!!participantToDelete}
        onClose={() => setParticipantToDelete(null)}
        onConfirm={handleDeleteConfirm}
        title="Supprimer l'intervenant"
        description={`Êtes-vous sûr de vouloir retirer ${participantToDelete?.name} de ce dossier ? Cette action est irréversible.`}
        confirmText="Supprimer"
      />
    </>
  );
}
